import { useIntl } from 'react-intl';
import { useRecordTypes } from '../../../hooks';
import { tString } from '../../../services';
import { RECORD_TYPES_FILTER_KEY } from '../constants';
export default function useFilterConfig() {
    var _a = useRecordTypes(), _b = _a.recordTypes, recordTypes = _b === void 0 ? [] : _b, isLoading = _a.isLoading;
    var intl = useIntl();
    var filterConfig = [
        {
            label: tString(intl, 'filter-label.status'),
            name: 'status',
            cql: 'status',
            values: ['Active', 'Inactive'],
        },
        {
            label: tString(intl, 'filter-label.visibility'),
            name: 'visibility',
            cql: 'visibility',
            values: ['Shared', 'Private'],
        }
    ];
    var recordTypeConfig = {
        label: tString(intl, 'filter-label.record-types'),
        name: RECORD_TYPES_FILTER_KEY,
        values: recordTypes === null || recordTypes === void 0 ? void 0 : recordTypes.map(function (item) {
            var _a;
            return ({
                value: "record_types.".concat((_a = item.id) !== null && _a !== void 0 ? _a : item.label),
                label: item.label,
            });
        }),
    };
    return {
        filterConfig: filterConfig,
        recordTypeConfig: recordTypeConfig,
        isLoadingConfigData: isLoading,
    };
}
